module.exports = __webpack_public_path__ + "img/logo.4f2c6dc4.png";